import {
  ConstraintFragment,
  ConstraintInAudienceFragment,
  ConstraintDaysOfWeekFragment,
  ConstraintTimeOfDayFragment,
  ConstraintRequiresActivation,
  ConstraintLocationInStateFragment,
  ConstraintRequiresVoucherFragment,
  ConstraintPurchaseThresholdFragment,
  ConstraintRequiresVoucherAvailableForDiscountFragment,
  ConstraintPreAuth,
  ConstraintStoreLocationFragment,
  ConstraintPaymentMethodFragment,
  ConstraintRequiresTransactionVoucherFragment,
  ConstraintPurchasableEligibilityFragment,
  ConstraintStoreLocationGroupFragment,
  ConstraintPaymentInstrumentFragment,
  ConstraintSubBrandFragment,
  ConstraintEmailRequiredFragment,
  ConstraintInStoreOnlyFragment,
  ConstraintOrderAheadOnlyFragment,
} from '@occc/graphql';

class ConstraintHelper {
  isInAudience = (constraint: ConstraintFragment): constraint is ConstraintInAudienceFragment => {
    return constraint.__typename === 'ConstraintInAudience';
  };

  isDaysOfWeek = (constraint: ConstraintFragment): constraint is ConstraintDaysOfWeekFragment => {
    return constraint.__typename === 'ConstraintDaysOfWeek';
  };

  isTimeOfDay = (constraint: ConstraintFragment): constraint is ConstraintTimeOfDayFragment => {
    return constraint.__typename === 'ConstraintTimeOfDay';
  };

  isRequiresActivation = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintRequiresActivation => {
    return constraint.__typename === 'ConstraintRequiresActivation';
  };

  isLocationInState = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintLocationInStateFragment => {
    return constraint.__typename === 'ConstraintLocationInState';
  };

  isRequiresVoucher = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintRequiresVoucherFragment => {
    return constraint.__typename === 'ConstraintRequiresVoucher';
  };

  isPurchaseThreshold = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintPurchaseThresholdFragment => {
    return constraint.__typename === 'ConstraintPurchaseThreshold';
  };

  isRequiresVoucherForDiscount = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintRequiresVoucherAvailableForDiscountFragment => {
    return constraint.__typename === 'ConstraintRequiresVoucherAvailableForDiscount';
  };

  isRequiresTransactionVoucher = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintRequiresTransactionVoucherFragment => {
    return constraint.__typename === 'ConstraintRequiresTransactionVoucher';
  };

  isPreAuth = (constraint: ConstraintFragment): constraint is ConstraintPreAuth => {
    return constraint.__typename === 'ConstraintPreAuth';
  };

  isStoreLocation = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintStoreLocationFragment => {
    return constraint.__typename === 'ConstraintStoreLocation';
  };

  isPaymentMethod = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintPaymentMethodFragment => {
    return constraint.__typename === 'ConstraintPaymentMethod';
  };

  isPurchasableEligibility = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintPurchasableEligibilityFragment => {
    return constraint.__typename === 'ConstraintPurchasableEligibility';
  };

  isStoreLocationGroup = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintStoreLocationGroupFragment => {
    return constraint.__typename === 'ConstraintStoreLocationGroup';
  };

  isPaymentInstrument = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintPaymentInstrumentFragment => {
    return constraint.__typename === 'ConstraintPaymentInstrument';
  };

  isSubBrand = (constraint: ConstraintFragment): constraint is ConstraintSubBrandFragment => {
    return constraint.__typename === 'ConstraintSubBrand';
  };

  isEmailRequired = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintEmailRequiredFragment => {
    return constraint.__typename === 'ConstraintEmailRequired';
  };

  isInStoreOnly = (constraint: ConstraintFragment): constraint is ConstraintInStoreOnlyFragment => {
    return constraint.__typename === 'ConstraintInStoreOnly';
  };

  isOrderAheadOnly = (
    constraint: ConstraintFragment,
  ): constraint is ConstraintOrderAheadOnlyFragment => {
    return constraint.__typename === 'ConstraintOrderAheadOnly';
  };
}

export const constraintHelper = new ConstraintHelper();
